/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-05-14 14:13:36
 * @FilePath: \crm-product\found\views\tpm\views\activity\material_usage_request\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import JudgeTime from '../../marketing_activity/utils';
import BudgetSubjectForm from '../components/budget_subject_table.vue';
import MaterialForm from '../components/material_table.vue';

formCreate.component('BudgetSubjectForm', BudgetSubjectForm);
formCreate.component('MaterialForm', MaterialForm);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      isControl: null,
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20260513000000002',
      fData: {},
      materialClassifyList: [],
      materialUnitList: [],
      buttons: {
        submit: true,
        close: true,
        submitAudit: true,
      },
      buttonText: {
        submit: '暂存',
        close: '关闭',
        submitAudit: '提交',
      },
    };
  },

  async created() {
    await this.getDictSelect();
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'actTime') { // 预计使用时间
        v.validate = {
          message: '预计使用时间不能为空',
          required: true,
          trigger: 'change',
        };
        v.props = {
          ...v.props,
          type: 'datetimerange',
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
          unlinkPanels: true,
          align: 'right',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        };
      }

      if (v.field === 'budget') {
        v.props = {
          ...v.props,
          saveRef: this.saveBudgetRef,
          startTime: '',
          endTime: '',
          isControl: this.isControl !== 'no_control',
        };
        v.value = {
          data: [],
        };
      }
      if (v.field === 'reqVos') {
        v.on = {
          ...v.on,
          addCloseTotal: this.addCloseTotal,
        };
      }
      if (v.field === 'totalPrice') {
        v.props = {
          ...v.props,
          controls: false,
        };
      }
      if (v.field === 'closeAttachmentList') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等类型',
        };
      }
      return v;
    },
    /**
     * 表单渲染完成后回调
     */
    async formComplete() {
      const reqVos = this.getRule('reqVos');
      const closeAllFlag = this.getRule('closeAllFlag');
      closeAllFlag.on = {
        ...closeAllFlag.on,
        change(e) {
          reqVos.props = {
            ...reqVos.props,
            closeAllFlag: e,
          };
        },
      };
      await this.init();
      if (this.formConfig.code === 'edit') {
        this.isControl = await JudgeTime.getControlType();
        this.getControlConfig();
      }
    },
    // 计算关闭合计总金额
    addCloseTotal(row) {
      this.setValue({
        curCloseAmount: row || 0,
      });
    },
    // 获取数据字典
    getDictSelect() {
      const params = [
        'tpm_material_classify',
        'material_base_unit',
      ];
      request.post('/mdm/mdmdictdata/batchDictSelect', params).then((res) => {
        if (res.success) {
          this.materialClassifyList = res.result.tpm_material_classify;
          this.materialUnitList = res.result.material_base_unit;
          const reqVos = this.getRule('reqVos');
          reqVos.props = {
            ...reqVos.props,
            materialClassifyList: this.materialClassifyList,
            materialUnitList: this.materialUnitList,
          };
        }
      });
    },
    // 获取管控配置
    getControlConfig() {
      if (!this.judgeTime) {
        this.judgeTime = new JudgeTime(this.formConfig.code !== 'add' ? {
          time: [
            `${this.formConfig.row.useStartTime}`,
            `${this.formConfig.row.useEndTime}`,
          ],
          model: this.getFormData(),
        } : null);
      }
    },
    saveBudgetRef(ref) {
      this.budgetRef = ref;
    },
    // 关闭提交
    closeSubmit(type) {
      const params = this.getFormData();
      if (!params) return false;
      const url = '/tpm/tpmactmaterialapply/addClose';
      const submitParams = {
        closeAllFlag: params.closeAllFlag,
        closeReason: params.closeReason,
        curCloseAmount: params.curCloseAmount,
        applyId: this.fData.id,
        applyTitle: this.fData.title,
        closeAttachmentList: params.closeAttachmentList,
        totalPrice: params.totalPrice,
        closeId: this.formConfig.row.id,
        submitFlag: type,
      };
      submitParams.closeDetailList = (params.reqVos || []).map((v) => ({
        materialId: v.materialId,
        num: v.num,
        price: v.price,
        preCloseAmount: v.preCloseAmount,
        preCloseNum: v.preCloseNum,
        curCloseAmount: v.curCloseAmount,
        curCloseNum: v.curCloseNum,
      }));
      request.post(url, submitParams).then((res) => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$emit('onClose');
          this.$emit('onGetList');
        }
      });
    },
    // 提交
    submit(type) {
      this.closeSubmit(type);
    },

    async init() {
      const {
        row,
      } = this.formConfig;
      const data = await request.post('/tpm/tpmactmaterialclose/queryDetailById', {
        id: row.id || this.id || '',
      }).then((res) => (res.success ? res.result : []));
      // 处理时间
      data.actTime = [`${data.useStartTime}`, `${data.useEndTime}`];
      // 费用预算编码
      data.budget = {
        data: data.budgetRespVos || [],
      };
      data.reqVos = (data.respVos || []).map((v) => {
        const obj = v;
        obj.classifyName = ((this.materialClassifyList || []).find((v1) => v1.dictCode === obj
          .classify) || {}).dictValue || '';
        obj.unitName = ((this.materialUnitList || []).find((v1) => v1.dictCode === obj
          .unit) || {}).dictValue || '';
        return obj;
      });
      const budgetCode = this.getRule('budget');
      budgetCode.props = {
        ...budgetCode.props,
        startTime: data.useStartTime,
        endTime: data.useEndTime,
      };
      this.fData = data;
      data.closeAttachmentList = data.closeAttachmentList || [];
      const reqVos = this.getRule('reqVos');
      reqVos.props.closeAllFlag = data.closeAllFlag;
      this.setValue(data);
    },
  },
};
